import type { RootAction } from 'RootTypes';
import { getType } from 'typesafe-actions';
import { fetchCurrentUser } from '@state/modules/api/actions';

import * as Actions from './actions';
import type { State, UserID } from './state';

const initialState: State = { isAuthenticated: false, isBatsAccountLinked: false };

export const reducer = (state = initialState, action: RootAction): State => {
    switch (action.type) {
        case getType(Actions.logOut):
            return { isAuthenticated: false };

        case getType(Actions.setAsAuthenticated):
            return { isAuthenticated: true };

        case getType(fetchCurrentUser.success):
            return {
                ...state,
                firstName: action.payload?.first_name,
                lastName: action.payload?.last_name,
                userID: action.payload?.id as UserID,
                email: action.payload?.email,
                isBatsAccountLinked: action.payload?.is_bats_account_linked,
                registrationDate: action.payload?.registration_date,
            };

        case getType(Actions.setSubscriptionInformation):
            return {
                ...state,
                bestSubscription: action.payload?.bestSubscription,
                highestAccessLevel: action.payload?.highestAccessLevel,
                isFreeTrialEligible: action.payload?.isFreeTrialEligible,
            };
        case getType(Actions.setAccountInformation):
            return {
                ...state,
                firstName: action.payload?.firstName,
                lastName: action.payload?.lastName,
                email: action.payload?.email,
            };
        default:
            return state;
    }
};
